class DigitalPayConfirmationDialogController {
    constructor($timeout, dialogRegistry) {
        this.$timeout = $timeout;
        this.dialogRegistry = dialogRegistry;
    }

    $onInit() {
        this.$timeout(() => {
            this.dialog = this.dialogRegistry.getDialog(this.dialogName);
        });
    }
}

DigitalPayConfirmationDialogController.$inject = ['$timeout', 'DialogRegistry'];

const digitalPayConfirmationDialogComponentDefinition = {
    controller: DigitalPayConfirmationDialogController,
    template: require('./digital-pay-confirmation-dialog.component.html').trim(),
    transclude: true,
    bindings: {
        dialog: '=',
        dialogName: '<',
        isWarningIcon: '<?',
        message: '<',
    },
};

module.exports = {
    DigitalPayConfirmationDialogController,
    digitalPayConfirmationDialogComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/wallet/common/digital-pay-confirmation-dialog.component.js